export default __webpack_public_path__ + "static/media/ic_web_dashboard.e5939723.png";